// extracted by mini-css-extract-plugin
export var deliveryRow = "_kq-a";
export var fixedHeight = "_kq-4";
export var freightLogo = "_kq-9";
export var fullWidth = "_kq-3";
export var priceColumn = "_kq-5";
export var radioSelected = "_kq-7";
export var radioUnselected = "_kq-6";
export var selectedOption = "_kq-2";
export var selectedOptionContainer = "_kq-1";
export var selection = "_kq-0";
export var tallSkeletonText = "_kq-8";